import { render, staticRenderFns } from "./newLayout5.vue?vue&type=template&id=48bf3068&scoped=true&"
import script from "./newLayout5.vue?vue&type=script&lang=js&"
export * from "./newLayout5.vue?vue&type=script&lang=js&"
import style0 from "./newLayout5.vue?vue&type=style&index=0&id=48bf3068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf3068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTooltip})
